import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, Grid } from '@mui/material';
import HeadingContainer from '../heading-container/HeadingContainer';

function Approaches() {
  const [approachesData, setApproachesData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_BASE_URI}/secure/admin/get/approaches`)
      .then(res => res.json())
      .then(data => {
        if (data && Array.isArray(data)) {
          setApproachesData(data);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching approaches", err);
        setLoading(false);
      });
  }, []);

  const displayApproaches = approachesData;
  
  // Preset icons to use if backend doesn't provide them
  const presetIcons = ["🧩", "🌻", "🌲", "🚀", "💡", "🧠", "🎯", "🌟"];

  return (
    <div style={{ background: 'linear-gradient(to bottom right, #fff1eb 0%, #ace0f9 100%)', minHeight: '80vh', paddingBottom: '80px' }}>
      <HeadingContainer title="Our Approaches" />
      <Container maxWidth="md" sx={{ mt: 6 }}>
        <Box sx={{ background: 'rgba(255,255,255,0.85)', backdropFilter: 'blur(20px)', borderRadius: '30px', p: 6, boxShadow: '0 20px 40px rgba(0,0,0,0.05)' }}>
          <Typography variant="h4" sx={{ textAlign: 'center', fontWeight: 800, mb: 4, color: 'var(--primary)', fontFamily: 'var(--font-heading)' }}>
            Blending the Best Practices
          </Typography>
          
          {loading ? (
             <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '150px' }}>
                 <div className="spinner" style={{ border: '4px solid rgba(0,0,0,0.1)', width: '36px', height: '36px', borderRadius: '50%', borderLeftColor: 'var(--primary)', animation: 'spin 1s linear infinite' }}></div>
                 <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
             </div>
          ) : (
             <Grid container spacing={4}>
               {displayApproaches.map((app, i) => {
                 const icon = app.iconUrl ? <img src={app.iconUrl} alt="icon" style={{width: '50px', height: '50px', objectFit: 'contain'}} /> : app.icon || presetIcons[i % presetIcons.length];
                 const detail = app.detail || app.description; // fallback if fetched from DB

                 return (
                   <Grid item xs={12} sm={6} key={app._id || i}>
                     <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '20px' }}>
                       <div style={{ fontSize: '3rem', background: 'white', width: '80px', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '20px', boxShadow: '0 10px 20px rgba(0,0,0,0.05)' }}>
                         {icon}
                       </div>
                       <div>
                         <Typography variant="h6" sx={{ fontWeight: 700, color: 'var(--text-main)' }}>{app.title}</Typography>
                         <Typography variant="body2" sx={{ color: 'var(--text-muted)', mt: 1, whiteSpace: 'pre-line' }}>{detail}</Typography>
                       </div>
                     </Box>
                   </Grid>
                 )
               })}
             </Grid>
          )}
        </Box>
      </Container>
    </div>
  );
}

export default Approaches;